import { EditNotifications } from "./edit_notifications";
import { Elderly } from "./elderly";
import { ElectricRickshaw } from "./electric_rickshaw";
import { ElectricalServices } from "./electrical_services";
import { Email } from "./email";
import { EmojiEvents } from "./emoji_events";
import { EmojiFoodBeverage } from "./emoji_food_beverage";
import { EmojiObjects } from "./emoji_objects";
import { EmojiPeople } from "./emoji_people";
import { Engineering } from "./engineering";

const iconsList = [
  { label: "EditNotifications", code: <EditNotifications /> },
  { label: "Elderly", code: <Elderly /> },
  { label: "ElectricRickshaw", code: <ElectricRickshaw /> },
  { label: "ElectricalServices", code: <ElectricalServices /> },
  { label: "Email", code: <Email /> },
  { label: "EmojiEvents", code: <EmojiEvents /> },
  { label: "EmojiFoodBeverage", code: <EmojiFoodBeverage /> },
  { label: "EmojiObjects", code: <EmojiObjects /> },
  { label: "EmojiPeople", code: <EmojiPeople /> },
  { label: "Engineering", code: <Engineering /> },
];

export {
  iconsList,
  EditNotifications,
  Elderly,
  ElectricRickshaw,
  ElectricalServices,
  Email,
  EmojiEvents,
  EmojiFoodBeverage,
  EmojiObjects,
  EmojiPeople,
  Engineering,
};
